import { compose, lifecycle, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { setRenderBVReviews } from 'components/common/hoc/withBazaarVoiceInlineRatings/actions'
import { getRenderBVReviews } from 'components/common/hoc/withBazaarVoiceInlineRatings/selectors'
import { ERROR_SCRIPT_NOT_LOADED } from '../../constants'
import BazaarVoiceReviews from './BazaarVoiceReviews'

const mapStateToProps = state => ({ renderBVReviews: getRenderBVReviews(state) })

const withGenerateBVReviews = withHandlers({
  generateBVReviews: ({ setRenderBVReviews, renderBVReviews }) => productId => {
    const intervalId = setInterval(() => {
      try {
        /* global $BV */
        if ($BV && $BV.ui) {
          clearInterval(intervalId)

          $BV.ui('rr', 'show_reviews', {
            productId
          })
          !renderBVReviews && setRenderBVReviews(true)
        }
      } catch (err) {
        console.log(ERROR_SCRIPT_NOT_LOADED, err)
        typeof renderBVReviews === 'boolean' ? setRenderBVReviews(null) : setRenderBVReviews(false)
      }
    }, 1000)
  }
})

const withLaunchBazaarVoiceScript = lifecycle({
  componentDidMount() {
    const { generateBVReviews, productId } = this.props
    generateBVReviews(productId)
  },
  componentDidUpdate({ productId: prevProductId }) {
    const {
      productId,
      renderBVReviews,
      generateBVReviews
    } = this.props

    if (!renderBVReviews) {
      generateBVReviews(productId)
    } else if (renderBVReviews && productId && prevProductId !== productId) {
      generateBVReviews(productId)
    }
  }
})

export default compose(
  connect(mapStateToProps, { setRenderBVReviews }),
  withGenerateBVReviews,
  withLaunchBazaarVoiceScript
)(BazaarVoiceReviews)
